import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';
import { updateTermsConsentCp } from '../../../redux/actions/index';
import { USER_PROFILE_UPDATE_CONSENT_FORM_ID } from '../../constants/form-ids';
import Btn from '../global/button';

import userProfileUpdateConsentValidation from '../../validation/user-profile-update-consent-validation';

import TranslatedCopy from '../../intl/translated-copy';
import logoAMRewards from '../../../images/am_rewards/fullAMRewardsBlue.svg';
import FormInputCheckbox from '../global/form-input-checkbox';


const mapStateToProps = state => {
  return ({
    contentForm: state.form[USER_PROFILE_UPDATE_CONSENT_FORM_ID],
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    userFirstName: state.UserProfileSession.userFirstName,
    userProfile: state.UserProfileSession.userProfile,
    userProfileCPNumber: state.UserProfileSession.userProfileCPNumber,
  });
};

class ModalUpdateConsent extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      handleSubmit,
      invalid,
      userFirstName,
    } = this.props;

    return (
      <div className='ModalLogin ModalUpdateConsent-content'>
        <div className='Modal-inner-login'>
          <div className='Modal-overlay Modal-overlay--isOpen' />
          <div className='Modal-body-login Modal-body--isOpen Modal-body--regular has-noDefaultTopBar' tabIndex='0'>
            <section className='ModalLogin-heading'>
              <TranslatedCopy className='ModalUpdateConsent-title' copyID='PROFILE_MODAL_TYC_TITLE_MODAL' />
              <button className='Modal-close Icon Icon--xThin' onClick={ () => this.onCloseModal() } />
            </section>
            <section className='ModalUpdateConsent-body'>
              <div>
                <img
                  alt='Aeromexico Rewards'
                  className='ModalUpdateConsent-img'
                  src={ logoAMRewards } />
              </div>
              <div className='ModalUpdateConsent-subtitle'>
                <TranslatedCopy
                  copyID='PROFILE_MODAL_TYC_WELCOME_MODAL'
                  firstName= { userFirstName }
                />
                <TranslatedCopy
                  className='ModalUpdateConsent-text'
                  copyID='PROFILE_MODAL_TYC_DESCRIPTION_MODAL'
                  tagName='p'
                />
              </div>
              <Form className='ModalUpdateConsent-form' onSubmit={ handleSubmit(() => this.onSubmitConsent()) }>
                <Field
                  className='FormInput--checkbox FormInput--full'
                  component={ FormInputCheckbox }
                  fieldLabel={ <TranslatedCopy copyID='PROFILE_MODAL_TYC_CHECKBOX_MODAL' /> }
                  inputClassModifier={ ['checkbox', 'full'] }
                  isRequired={ true }
                  labelClassModifier='checkbox'
                  name='userProfileTermsAndConditions'
                />
                <Field
                  className='FormInput--checkbox FormInput--full'
                  component={ FormInputCheckbox }
                  fieldLabel={ <TranslatedCopy copyID='PROFILE_MODAL_ADP_CHECKBOX_MODAL' /> }
                  inputClassModifier={ ['checkbox', 'full'] }
                  isRequired={ true }
                  labelClassModifier='checkbox'
                  name='privacyPolicy'
                />
                <Btn
                  block={ true }
                  btnType='submit'
                  className='Btn--filledRed'
                  copyID='PROFILE_MODAL_TYC_MODAL_CHECKBOX'
                  filled={ true }
                  visuallyDisabled ={ invalid }
                />
              </Form>
            </section>
          </div>
        </div>
      </div>
    );
  }

  onCloseModal = () => {
    const {
      closeModal,
      dispatch,
      onSignOut,
    } = this.props;

    dispatch(sendAnalytics({
      eventCreator: manageTracking.updateConsentCp({
        eventAction: 'Declined',
        eventLabel: 'Success',
      }),
    }));

    onSignOut();
    closeModal();
  }

  onSubmitConsent = () => {
    const {
      closeModal,
      dispatch,
      userProfile,
    } = this.props;

    const data = {
      'consents':[
        {
          'code': 'PVCD',
          'status': 'Y',
        },
        {
          'code': 'TNC',
          'status': 'Y',
        },
      ],
      'ffNumber': `00${userProfile.ffNumber}`,
    };

    dispatch(updateTermsConsentCp(data));
    closeModal();
  }
}

ModalUpdateConsent = reduxForm({
  destroyOnUnmount: false,
  form: USER_PROFILE_UPDATE_CONSENT_FORM_ID,
  validate: userProfileUpdateConsentValidation,
})(ModalUpdateConsent);

ModalUpdateConsent = connect(mapStateToProps)(ModalUpdateConsent);

export default ModalUpdateConsent;

